export default __webpack_public_path__ + "static/media/icon_nature.608700b4.svg";